import { StarFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './SpecialRequestTooltip.module.scss';

export function SpecialRequestTooltip() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'personalization.summary',
  });

  return (
    <Tooltip
      placement="right"
      title={t('specialRequestTooltip')}
      className={styles.specialRequestIcon}
    >
      <StarFilled />
    </Tooltip>
  );
}
